export default __webpack_public_path__ + "ed7a207a4220230258cdfc9a02cadc9e.png";